import { render, staticRenderFns } from "./payError.vue?vue&type=template&id=61399f98"
import script from "./payError.vue?vue&type=script&lang=js"
export * from "./payError.vue?vue&type=script&lang=js"
import style0 from "./payError.vue?vue&type=style&index=0&id=61399f98&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports